import React, { FC } from 'react';

export const FiltersPanel: FC<React.PropsWithChildren> = ({ children }) => {
  return <div data-name="FiltersPanel">{children}</div>;
};
